import { Block } from '@chameleoncreator/creator-app';


export const setBlockLocalAction = (block: Block) => {
  return {
    type: 'SET_BLOCK',
    data: block,
  };
};
